
<router-outlet></router-outlet>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.6)" size = "small" color = "#fff" type = "square-jelly-box" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>